import moment from 'moment';

export default function DeviceActivationsBulkCustomController($rootScope, BulkActivationService) {
  'ngInject';

  const vm = this;
  // Needs to be disabled if security mode is not open
  vm.enabled = $rootScope.currentUser.securityMode === 'Open';
  vm.uploadBulkActivation = uploadBulkActivation;
  resetState();

  function resetState() {
    vm.loading = false;
    vm.errorMsg = '';
    vm.activationJob = null;
  }

  function uploadBulkActivation() {
    if (vm.loading) return;
    resetState();
    const f = document.getElementById('CsvFile').files[0];

    vm.loading = true;

    BulkActivationService.bulkActivate(f)
      .then((response) => {
        vm.activationJob = response.data;
      })
      .catch((error) => {
        const { message } = error.data;
        vm.errorMsg = message || 'Something went wrong!';
      })
      .finally(() => {
        vm.loading = false;
      });
  }
}
